import { useAppSelector } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import { getCompanyState } from './companySlice';

const useCompany = () => {
  const { company, companyIdIri, companyId, companyStats } =
    useAppSelector(getCompanyState);

  return {
    company,
    companyIdIri,
    companyId,
    companyStats: companyStats.result,
    companyStatsStatusPending: companyStats.apiStatus === APIStatus.PENDING,
  };
};

export default useCompany;
